import { render, staticRenderFns } from "./questionGroup.vue?vue&type=template&id=d1a8ea88&"
import script from "./questionGroup.vue?vue&type=script&lang=js&"
export * from "./questionGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1a8ea88')) {
      api.createRecord('d1a8ea88', component.options)
    } else {
      api.reload('d1a8ea88', component.options)
    }
    module.hot.accept("./questionGroup.vue?vue&type=template&id=d1a8ea88&", function () {
      api.rerender('d1a8ea88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/testTaker/questionGroup.vue"
export default component.exports